import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const ClientModal = ({ open, onOpenChange, editClient, clientForm, setClientForm, onSave }) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-slate-800 border-slate-700 text-white" data-testid="client-modal">
        <DialogHeader>
          <DialogTitle>{editClient ? "Modifier le client" : "Ajouter un client"}</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <div className="space-y-2">
            <Label>Nom *</Label>
            <Input
              value={clientForm.name}
              onChange={(e) => setClientForm({ ...clientForm, name: e.target.value })}
              className="bg-slate-700 border-slate-600"
              data-testid="client-name-input"
            />
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-2">
              <Label>Téléphone</Label>
              <Input
                value={clientForm.phone}
                onChange={(e) => setClientForm({ ...clientForm, phone: e.target.value })}
                className="bg-slate-700 border-slate-600"
                data-testid="client-phone-input"
              />
            </div>
            <div className="space-y-2">
              <Label>Email</Label>
              <Input
                value={clientForm.email}
                onChange={(e) => setClientForm({ ...clientForm, email: e.target.value })}
                className="bg-slate-700 border-slate-600"
                data-testid="client-email-input"
              />
            </div>
          </div>
          <div className="space-y-2">
            <Label>Notes</Label>
            <Input
              value={clientForm.notes}
              onChange={(e) => setClientForm({ ...clientForm, notes: e.target.value })}
              className="bg-slate-700 border-slate-600"
              data-testid="client-notes-input"
            />
          </div>
          <Button
            onClick={onSave}
            className="w-full bg-pink-500 hover:bg-pink-600"
            data-testid="client-save-btn"
          >
            Enregistrer
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ClientModal;
